// Vendor Libs
import React, {useEffect} from 'react';

// Dish Tech React
import {CrudDataTable, Overlay} from '@dishtech-react/core';
import {useForm, useOverlay, useService} from '@dishtech-react/hooks';
import {useSelector} from 'react-redux';

// Components
import LoadingSpinner from '../layout/loading-spinner';
import UserForm from './user-form';

// Config
import {serviceConfig} from '../../../config/service-config';
import {tableConfig} from '../../../config/table-config';

const SERVICE_KEY = 'USER';

const User = () => {
    const {serviceContent, registerService, unregisterService} = useService(SERVICE_KEY);
    const {registerForm, setFieldValues} = useForm(serviceConfig, SERVICE_KEY, 'update');
    const {content: users = []} = serviceContent;
    const {columns} = tableConfig[SERVICE_KEY];
    const fetching = useSelector(state => (state.service && state.service.USER ? state.service.USER.fetching : true));

    const {
        closeOverlay: closeCreateOverlay,
        open: isCreateOverlayOpen,
        openOverlay: openCreateOverlay,
        overlayId: createOverlayId,
    } = useOverlay({
        title: 'create_user',
    });
    const {
        closeOverlay: closeUpdateOverlay,
        open: isUpdateOverlayOpen,
        openOverlay: openUpdateOverlay,
        overlayId: updateOverlayId,
    } = useOverlay({
        title: 'update_user',
    });

    useEffect(() => {
        registerService();

        return () => unregisterService();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUpdateButtonClick = userId => {
        const promise = registerForm();
        const formValues = users.find(user => user.userId === userId);

        promise.then(() =>
            setFieldValues({
                ...formValues,
                roleIds: formValues.roles.map(({roleId}) => roleId),
            }).then(() => {
                openUpdateOverlay();
            })
        );

        return promise;
    };

    return fetching ? (
        <LoadingSpinner />
    ) : (
        <>
            <CrudDataTable
                canCreate={true}
                canUpdate={true}
                columnConfig={columns}
                data={users.map(({active, roles, ...user}) => ({
                    active: active ? 'active' : 'inactive',
                    roles: roles.map(({name, client: {clientId}}) => `${clientId}_${name}`.toLowerCase()).sort(),
                    ...user,
                }))}
                idKey="userId"
                itemLabel="User"
                options={{
                    selectableRows: 'none',
                }}
                title="User Management"
                onCreate={openCreateOverlay}
                onUpdate={handleUpdateButtonClick}
            />
            <Overlay id={createOverlayId} open={isCreateOverlayOpen} title="Create User">
                <UserForm onCancel={closeCreateOverlay} onSave={closeCreateOverlay} />
            </Overlay>
            <Overlay id={updateOverlayId} open={isUpdateOverlayOpen} title="Update User">
                <UserForm mode="update" onCancel={closeUpdateOverlay} onSave={closeUpdateOverlay} />
            </Overlay>
        </>
    );
};

export default User;
